import React from "react"

import { connect } from 'react-redux';

import {
    Card, CardBlock, CardTitle,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Input,
    Badge,
    Row,Modal, ModalHeader, ModalBody, ModalFooter,Tooltip ,Label,FormGroup,
} from 'reactstrap';

import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';

import lodash from "lodash";

import { Redirect, Link } from 'react-router-dom';
/*editor*/
import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import Select, {Async} from 'react-select';
import 'react-select/dist/react-select.css';
import ReactTable from "react-table";
import "react-table/react-table.css";

import moment from 'moment';

import _ from 'underscore';

import swal from 'sweetalert2';

import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import FAfloppyO from 'react-icons/lib/fa/floppy-o';
import FAdollar from 'react-icons/lib/fa/dollar';
import FAban from 'react-icons/lib/fa/ban';
import FAprint from 'react-icons/lib/fa/print';
import FaFac from 'react-icons/lib/fa/file-text';
import FaEdit from 'react-icons/lib/fa/edit';
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o';
import FaCel from 'react-icons/lib/fa/phone';
import IconEdit from 'react-icons/lib/md/edit';
import IconNote from 'react-icons/lib/md/check-circle';
import IconRetorno from 'react-icons/lib/md/reply-all';
import IconCheck from 'react-icons/lib/fa/check-square-o';

import Icono_facturar  from "react-icons/lib/md/check-circle";



import IconInfo from 'react-icons/lib/fa/info-circle';
import { FaPlus,FaUndo } from "react-icons/lib/fa";



import * as actions from '../../actions/combos';



import ModalTablas from '../catalogos/modal_tablas';


import {api, request, API_URL} from '../../actions/_request';



const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
class TicketForm extends React.Component {

    constructor(props) {

        super(props)
        // console.log('id usuario--->',parseInt(this.props.auth.user.id));

        this.state = {
            ticket: {
                
                descripcion: '',
                clave: '',
                activo: 1,
                id: 0,
                total:0,
                
            },
            items: [],
            editorState: null,
            cliente: null,
            modal : false,
            modalCliente : false,
            cliente_id : null,
            title       : "",
            modalEstado : false,
            edit : false,
            action: 'save',
            dropdownOpen: false,
            showSign: true,
            departamentos:[],
            llamadas:[],
            rows:[],
            paquetes:0,
            total:0,
            subtotal:0,
            iva:0,
            index:0,
            modal_descripcion:false,
            usuarios:[],
            modal_factura:false,
            modal_correo:false,
            factura:[],
            activeTab: '1',
            compras:[],
            descripcion_compra:'',
            bandera_precio: true,
            bandera_inicio:false,
            
        };

        
        this.handleSelectChange     = this.handleSelectChange.bind(this);   
        this.submit                 = this.submit.bind(this);
        this.updatecampos               = this.updatecampos.bind(this);
        this.addRow                 = this.addRow.bind(this);
        this.deleteRow              = this.deleteRow.bind(this);
        this.sacar_total                = this.sacar_total.bind(this);
        this.modal_descripcion              = this.modal_descripcion.bind(this);
        this.handleChangedescripcion                = this.handleChangedescripcion.bind(this);
        this.cambiar_total              = this.cambiar_total.bind(this);
        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);
        this.total_precios= this.total_precios.bind(this)
  
    }

    truncado (sVal, nDec = 0) {
      // var s = x.toString()
      // var l = s.length
      // var decimalLength = s.indexOf('.') + 1
      // var numStr = s.substr(0, decimalLength + posiciones)
      // return Number(numStr)


        var num = parseFloat(sVal); 
        // var s = "0.00"; 
        // if (!isNaN(n)){ 
        //  n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
        //  s = String(n); 
        //  s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
        //  s = s.substr(0, s.indexOf(".") + nDec + 1); 
        // } 
         var s = num.toFixed(3);

        return parseFloat( s); 
    }

     retorno(objeto,campo,vacio=0,valor=""){
        // console.log('renglon---->',objeto);
        // console.log('campo---->',campo);

        
            let self =this;
            let id=objeto.value?objeto.value:objeto.id;
            if(campo!='actualizar'){
                self.addRow(objeto);
                self.toggle_modal();
            }else{
                var rows = this.state.rows;
                var index = this.state.index;
                rows[index].inventario_id = id;
                rows[index].clave = objeto.codigo_interno;
                 rows[index].descripcion = objeto.nombre;
                this.setState({rows: rows});
                self.toggle_modal();
            }
            

    }
    toggle_modal(index=26,catalogo="",campo=""){  

        this.setState({
            modal_articulo : !this.state.modal_articulo,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }
    componentDidMount() {
    /*
    tipos
    1.- factura,
    2.- inventario
    3.- ticket,
    4.- cotizacion,

    */
    console.log('inicio articulos combo')
    console.log('props componentDidMount ---->',this.props);
    let ticket={ total:this.props.precio};
        // if(this.props.tipo!=1)
             this.setState({rows: this.props.articulos,bandera_inicio:true,ticket:ticket});
             console.log('ticket ---->',ticket);
         // if(parseInt(this.props.tipo)==3)
         console.log('articulos----->',this.props.articulos.length)
         if(this.props.articulos.length>0)
            this.total_precios(this.props.precio,this.props.articulos);

    }

    componentWillReceiveProps(nextProps){

            let ticket_ahora = this.state.ticket;

        
            // console.log('precio---->',nextProps.precio);
            console.log('nextProps componentWillReceiveProps ---->',this.nextProps);
            if (typeof nextProps === 'undefined') {
   
            }else{

                if(nextProps.precio!==ticket_ahora.total&&nextProps.combo){
                    //Perform some operation
                    var rows = this.state.rows;
                    // console.log('Cambio de precio---->',nextProps.precio);
                    // console.log('this.props.precio---->',this.props.precio);
                    if (typeof rows === 'undefined')
                        rows=[];
                    var bandera_precio = this.state.bandera_precio;
                    var bandera_inicio = this.state.bandera_inicio;
                     this.setState({bandera_precio: false });
                    if(rows.length>0&&bandera_inicio){
                        console.log('modificacion del total ------------------->')
                     this.total_precios(nextProps.precio,rows);
                    }

                   
                     
                  }
                  if(nextProps.articulos!==this.props.articulos){
                    let ticket={ total:nextProps.precio};
                    //Perform some operation
                     // console.log('articulos---->');
                     let rows=nextProps.articulos;
                     if (typeof nextProps.articulos === 'undefined')
                        rows=[];
                     this.setState({rows: rows,bandera_inicio:true,ticket:ticket});
                       this.total_precios(nextProps.precio,rows);
                  }
            }

        

      
    }
    addRow(producto) {

        var rows = this.state.rows;
        let paquetes=parseInt( this.state.paquetes);
        let ticket = this.state.ticket;
        let self =this;
        let descripcion='';
        
            descripcion=producto.nombre;
            rows.unshift({
                id:null,
                inventario_id:producto.id,
                clave:producto.codigo_interno,
                descripcion:descripcion,                        
                precio:producto.contado,
                costo:producto.costo,
                cantidad:1,
                porcentaje:0,
                total:producto.contado,
                categoria_id:producto.categoria_id,
            });         
        this.sacar_total(rows);
          
    }
    modal_descripcion(index=0){
        this.setState({
            modal_descripcion : !this.state.modal_descripcion,
            index:index
        })
    }
    handleChangedescripcion(event)
    {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        var rows = this.state.rows;
        var index = this.state.index;
        rows[index].descripcion = value;
        this.setState({rows: rows});
    }

    deleteRow(index) {
        swal({
        title: 'Estas seguro?',
        text: "Se eliminara  el producto de la lista!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!'
        }).then((result) => {
            if (result.value) {
                var rows = this.state.rows;
                let ticket = this.state.ticket;
                let self = this;
                rows.splice(index, 1);
                this.setState({
                    rows: rows,
                });
                this.sacar_total(rows);
                document.getElementById('body').className = "modal-open ";
                this.props.alerta({
                    mensaje:"Se elimino de la lista.",
                    tipo:"success",
                    creacion:moment().format('Y-MM-DD H:m:s'),
                  });  
            }
        })
    }
    

    updatecampos(val, index,campo) {
        let rows = this.state.rows;
        let cliente=this.cliente;
        let paquetes=parseInt( this.state.paquetes);
        let ticket = this.state.ticket;
        ////////console.log(cliente);
        let anterior =rows[index][campo];
        rows[index][campo] =parseFloat( val);
    
        // console.log(campo);
        // console.log(rows[index][campo]);
        let bandera=true;
        let porcentaje=true;
        
        switch(campo)
        {
            case "total":
                bandera=false;          
            break;  
            case "porcentaje":
                porcentaje=false;           
            break;      
            default:
            break

        }
        if(porcentaje){
            if(bandera){
                // console.log('sacar total')
                this.sacar_total(rows);
            }else{
                // console.log('cambiar total')
                this.cambiar_total(rows);
            }

        }else{
            this.total_precios(this.props.precio,rows);
        }       
    }

    cambiar_total(lista)
    {
        var rows = lista;
        // console.log(rows);
        let ticket=this.state.ticket;
        let total=0;
        let iva=0;
        let subtotal=0;  
        let costo=0;   
        if(rows.length> 0) 
        {
            for (var index = rows.length - 1; index >= 0; index--) 
            {       
                var cantidad=parseInt(rows[index].cantidad,10);
                if(isNaN(cantidad)){
                    cantidad=0;
                    rows[index].cantidad='';
                }
                let precio=( rows[index].total/cantidad).toFixed(3);
                rows[index].precio= parseFloat(    precio     );
                total=parseFloat(total)+ parseFloat(rows[index].total);
                costo+=parseFloat(rows[index].costo)*cantidad;
                // console.log('precio--->',precio);
                // console.log('precio parse--->',parseFloat( this.trunc(precio,2)))
                // console.log('cantidad--->',cantidad);

            }       
        }
        ticket.total=total.toFixed(3);


        this.setState({
            ticket:ticket,
            rows:rows,
            bandera_precio:true,
        });
        this.props.actualizar(ticket.total,rows,costo);
    }
    sacar_total(lista) {
        var rows = lista;
        let ticket=this.state.ticket;
        let total=0;
        let iva=0;
        let subtotal=0; 
         let costo=0;       
        if(rows.length> 0) 
        {
            for (var index = rows.length - 1; index >= 0; index--) 
            {       
                var cantidad=parseInt(rows[index].cantidad,10);
                if(isNaN(cantidad)){
                    cantidad=0;
                    rows[index].cantidad='';
                }
                let PL=parseFloat(rows[index].precio);
                var t=PL*cantidad;
                // console.log("total: "+t)
                rows[index].total=parseFloat( t.toFixed(3));
                // console.log('cantidad--->',cantidad);
                total=parseFloat(total)+ parseFloat(rows[index].total.toFixed(3));
                costo+=parseFloat(rows[index].costo)*cantidad;
            }   
        }
        ticket.total=total.toFixed(3);
        ticket.costo=costo.toFixed(2);
        this.setState({
            ticket:ticket,
            rows:rows,
            bandera_precio:true,
        });
        this.props.actualizar(ticket.total,rows,costo.toFixed(2));
    }
    trunc (value, nDec = 0) {
      // var s = x.toString()
      // var l = s.length
      // var decimalLength = s.indexOf('.') + 1
      // var numStr = s.substr(0, decimalLength + posiciones)
      // return Number(numStr)
        // var n = parseFloat(sVal); 
        // var s = "0.00"; 
        // if (!isNaN(n)){ 
        //  n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
        //  s = String(n); 
        //  s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
        //  s = s.substr(0, s.indexOf(".") + nDec + 1); 
        // } 
        // return s; 


        var decimals =  2;
        var  separators =[',', ",", '.'];
        var number = (parseFloat(value) || 0).toFixed(decimals);
        if (number.length <= (4 + decimals))
            return '' +number.replace('.', separators[separators.length - 1]);
        var parts = number.split(/[-.]/);
        value = parts[parts.length > 1 ? parts.length - 2 : 0];
        var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
        var start = value.length - 6;
        var idx = 0;
        while (start > -3) {
            result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
            idx = (++idx) % 2;
            start -= 3;
        }
        return  result;
    }

    handleSelectChange(select, name) {

        let {rows} = this.state;
        const value = select === null ? null : select.value;
        this.setState({
            ticket: {
                ...this.state.ticket,
                [name]: value
            }
        });
        if(name=='total')
                this.total_precios(value,rows,1);
    }

    total_precios(total,rows,opcion=2){
         let costo=0;  
         let gran_total=0;
        if(rows.length> 0) 
        {
            for (var i = rows.length - 1; i >= 0; i--) 
            {        
                let porcentaje=parseFloat( rows[i].porcentaje);
                if( porcentaje>0)
                {
                    let precio=0;
                    let total_producto=0;
                    let cantidad=parseFloat( rows[i].cantidad);
                    total_producto=((parseFloat(total)*porcentaje)/100).toFixed(3);
                    precio=parseFloat(total_producto)/cantidad;
                    // console.log('porcentaje --->',porcentaje);
                    // console.log('precio --->',precio);
                    // console.log('cantidad --->',cantidad);
                    // console.log('total_producto --->',total_producto);
                    // console.log('total --->',parseFloat(total));
                    rows[i].total=parseFloat( total_producto);
                    rows[i].precio=parseFloat( precio .toFixed(3));
                    costo+=parseFloat(rows[i].costo)*cantidad;
                    gran_total+=parseFloat( total_producto);
                }  
            }  
        }
        if(opcion==2)
            gran_total=parseFloat(total);

        this.setState({
            rows:rows,
             ticket: {
                ...this.state.ticket,
                costo: costo.toFixed(2),
                total: gran_total,
               
            }
        });
        this.props.actualizar(gran_total,rows,costo.toFixed(2),opcion);

    }
    submit() {
            let self = this;

        let {ticket,rows,action} = this.state;
        if(this.props.combos.saving){
            swal("Oops..", "Estamos en Proceso  ","warning");
            return false;
        }
        // console.log('entro al submit')
        let save = true;
        let venta = true;
        let lista=true;  
        let vacio=true;
        var items           = [];
        if(rows.length === 0) {
            vacio = false;  
        }
        if(rows.length > 0){
            // console.log('entreo a revisar los items');
            var producto="";
            var dato="";
            var total_porcentaje=0;
            var bandera_porcentaje=false;

            rows.some(function(obj) {
                

                var precio = parseFloat(obj.precio, 10);
                var porcentaje = parseFloat(obj.porcentaje, 10);
                var cantidad = obj.cantidad;
                var id = parseInt(obj.inventario_id, 10);
                var descripcion = obj.descripcion;
                // console.log("item: ",obj);

                if(descripcion==="" || descripcion==null)
                {
                    lista = false;
                    dato=" la Descripción";
                    producto=obj.producto.descripcion;
                    return false;
                }
                if(cantidad==="" || cantidad==null)
                {
                    lista = false;
                    dato=" el Cantidad esta Vacio";
                    producto=obj.producto.descripcion;
                    return false;
                }
                if( precio === 0 || isNaN(precio)) {
                    //////console.log("precio error");
                    lista = false;
                    dato="el Precio";
                    producto=obj.producto.descripcion;
                    return false;
                }
                if( porcentaje === 0 || isNaN(porcentaje)) {
                    //////console.log("precio error");
                    lista = false;
                    dato="el Porcentaje";
                    producto=obj.producto.descripcion;
                    return false;
                }else{
                    total_porcentaje+=porcentaje;
                    if(porcentaje>1)
                        bandera_porcentaje=true;
                }

                items.push({
                    id:obj.id,
                    inventario_id:obj.inventario_id,
                    precio:obj.precio,
                    total:obj.total,
                    descripcion:obj.descripcion,
                    cantidad:obj.cantidad,  
                    porcentaje:obj.porcentaje,                                  
                });

            });

            
        }
        ticket.items = items;
        // console.log(ticket.items);
        if(bandera_porcentaje){
            if(total_porcentaje!=100)
                swal("Oops..", "Por favor Verificar los Procentajes estos tienen que sumar 100% ");     
            return;
        }
        if(!vacio) {
                swal("Oops..", "Por favor Verificar los Productos se Encontraron datos incorrectos ");      
            return;
        }
        if(!lista) {            
                swal("Oops..", "Por favor Verificar los Productos se Encontraron datos incorrectos en "+ dato+"  en el producto "+producto, "error");       
            return;
        }
        const {params} = this.props.match;
        let check = ['descripcion', 'clave'];
        // console.log('ticket submit---->',ticket);
        for(let i in check) {
            let key = check[i];
            let value = ticket[key];
            if(value == '' || value == null){
                save = false;
                // console.log('Campo--->',key);
            }
        }
        if(!save) {
            swal("Oops..", "Por favor acompleta todos los campos", "error");
            return;
        }
        // update
        // if(params.id) {

        this.props[action](ticket, (response) => {
            if(response.status){
                swal("Bien hecho!", "El Combo fue Guardado con éxito!", "success");
                this.props.history.push('/combos');
            }else{
                swal("Error!", "La Clave ya esta Registrada", "error");
            }
        });
    }
    formateo(value) {
        var decimals =  2;
        var  separators =[',', ",", '.'];
        var number = (parseFloat(value) || 0).toFixed(decimals);
        if (number.length <= (4 + decimals))
            return '$' +number.replace('.', separators[separators.length - 1]);
        var parts = number.split(/[-.]/);
        value = parts[parts.length > 1 ? parts.length - 2 : 0];
        var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
        var start = value.length - 6;
        var idx = 0;
        while (start > -3) {
            result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
            idx = (++idx) % 2;
            start -= 3;
        }
        return '$' + result;
    }
    render() {

        let {ticket, editorState,rows} = this.state;

        // const {params} = this.props.match;

        let {edit} = this.state;

        let show = false;


        let rol =parseInt( this.props.auth.user.rol);
        let departamento =parseInt( this.props.auth.user.departamento);
        //console.log(ticket.tipo_precios);

        if (typeof rows === 'undefined') {
        rows=[];
        // console.log('rows undefined-->',rows)
}


        return(
          




                    <Card className="mb-4">
                        <CardBlock>
                <div className="row mb-4">
              
              {  false&&
                <div className='col-3'>
                   <div className="form-group">
                                <label> Precio</label>

                                 <Input
                                    type="number"
                                    step='1'
                                    name='total'
                                    className="form-control texto_normal" 
                                    value={this.state.ticket.total}
                                     onChange={ (e) => _.debounce(this.handleSelectChange(e.target,e.target.name), 10000) }
                                     readOnly= {rows.length>0?false:true}
                                />
                            </div>
                </div>

              }
                { this.props.tipo!=2 &&
                <div className='col-3'>
                   <div className="form-group">
                                <label> Costo</label>

                                 <Input
                                    type="text"
                                    name='total'
                                    className="form-control texto_normal" 
                                    value={this.formateo(this.state.ticket.costo)}
                                    
                                     readOnly
                                />
                            </div>
                    </div>
                                    }
                        <div className="col-12 col-md-12">                          
                            <table className="table tabla_items">
                                <thead>
                                    <tr>
                                        <th>Codigo</th>
                                        <th>Descripción</th>
                                        <th>costo</th>
                                        <th>Precio </th>
                                        <th>Cantidad</th>
                                        <th>Procentaje</th>
                                        <th>Total</th>
                                        <th>
                                        <Button color="primary" outline onClick={ (button) => { this.toggle_modal(26,"Productos","inventario_id") } }>Agregar</Button>
                                </th>
                                    </tr>
                                </thead>
                                <tbody className="">
                                    {rows.map((item, i) => 
                                        <tr key={i}>

                                        <td width="10%">
                                                {
                                                (parseInt(item.inventario_id)===0)?
                                                <Button
                                                  color="success" 
                                                  title="Agregar Codigo Inventario"  
                                                  onClick={(button) => {
                                                   this.setState({
                                                        index:i
                                                    })
                                                   this.toggle_modal(26,"Productos","actualizar"); }

                                                  }>
                                                    <IconCheck/>
                                                </Button>:item.clave
                                                }
                                                
                                            </td>
                                            <td >
                                                {item.descripcion}
                                            </td>
                                             <td >
                                                { this.formateo( item.costo)}
                                            </td>




                                            <td width="10%">
                                                <Input
                                                  type="number"
                                                  name="precio"
                                                  value={item.precio} 
                                                  onChange={ (e) => _.debounce(this.updatecampos(e.target.value, i,e.target.name),1500 )}
                                                
                                                  />
                                                  
                                            </td>

                                            <td width="5%">
                                                <Input
                                                  type="number"
                                                  name="cantidad"
                                                  value={item.cantidad} 
                                                   onChange={ (e) => this.updatecampos(e.target.value, i,e.target.name) }
                                                   />
                                            </td>
                                            <td width="10%">
                                                <Input
                                                  type="number"
                                                  name="porcentaje"
                                                  value={item.porcentaje} 
                                                  onChange={ (e) => _.debounce(this.updatecampos(e.target.value, i,e.target.name),1500 )}
                                                  />
                                                  
                                            </td>

                                            <td width="10%">
                                                <Input
                                                  type="number"
                                                  name="total"
                                                  value={item.total} 
                                                   onChange={ (e) => _.debounce(this.updatecampos(e.target.value, i,e.target.name), 1000) }
                                                  />
                                            </td>
                                            
                                            <td width="10%">
                                                 <div className="text-right">
                                                <Button
                                                  color="danger"
                                                 onClick={this.deleteRow.bind(this, i)}>
                                                    X
                                                </Button>
                                                {'  '}
                                                {
                                                (parseInt(item.categoria_id)===10||parseInt(item.inventario_id)===0)&&
                                                <Button
                                                  color="primary"   
                                                 onClick={this.modal_descripcion.bind(this, i)}>
                                                    <IconEdit/>
                                                </Button>
                                                }
                                                </div>
                     
                                                   
                                            </td>
                                            
                                            
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            </div>

                        {this.props.tipo!=3&&
                            <div className="my-4 separador"/>
                        }{this.props.tipo!=3&&
                            <div className="my-4 separador"/>
                        }
                    </div>



                 { this.state.modal_articulo&&
                <ModalTablas
                    open={this.state.modal_articulo}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    no_agregar={false}
                />
            }

          
            
             


                   {
                    (rows.length>0&&parseInt(this.state.index)>=0)&&
                    <Modal isOpen={this.state.modal_descripcion} toggle={this.modal_descripcion} className="default modal-lg">
                
                <ModalHeader toggle={this.modal_descripcion}>Descripción  del Producto</ModalHeader>
                <ModalBody>

                    <div className="row">
                       
                        <div className="col-sm-11">
                            <div className="form-group">
                                <label htmlFor="">{parseInt(rows[parseInt( this.state.index)].categoria_id)!==10?"Descripción":"Descripción  Servicio de:"}</label>
                                <input 
                                 type="text" 
                                 name="descripcion" 
                                 value={rows[parseInt( this.state.index)].descripcion}
                                 onChange={this.handleChangedescripcion} 
                                 className="form-control texto_normal" 
                                 maxLength={599}/>
                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    
                        
                        <div>
                            <Button color="success"  onClick={this.modal_descripcion} >
                                &nbsp;Guardar
                            </Button>{' '}
                            <Button color="danger" onClick={this.modal_descripcion}>
                                Cancelar
                            </Button>
                        </div>
                    
                </ModalFooter>
                
            </Modal>
                   }
                

                        </CardBlock>
                    </Card>


            
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        combos: state.combos,
        auth:state.auth,
        notificciones:state.notificciones,
    }
};

export default connect(mapStateToProps, actions)(TicketForm)





// WEBPACK FOOTER //
// ./src/components/articulosCombo/index.js